/* rotating-wordmark.js
   Cycles the middle word of the header wordmark ("Guevara Office Supplies" ->
   "Guevara Safety Supplies" ...). The words and the interval come from
   snippets/rotating-wordmark.liquid, which reads them from the Header section settings. */

if (!customElements.get('rotating-word')) {
  class RotatingWord extends HTMLElement {
    connectedCallback() {
      this.words = Array.from(this.querySelectorAll('.guevara-wordmark__word'));
      if (this.words.length < 2) return;

      // Milliseconds between words; floored at 1s so a bad setting can't make it strobe
      this.interval = Math.max(1000, parseInt(this.dataset.interval, 10) || 2000);

      // Start on whichever word Liquid marked active (the first one)
      this.index = Math.max(0, this.words.findIndex((w) => w.classList.contains('is-active')));

      // Pause while the tab is in the background so it doesn't spin needlessly
      this.onVisibility = () => (document.hidden ? this.stop() : this.start());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.start();
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    start() {
      if (this.timer) return;
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const current = this.words[this.index];
      this.index = (this.index + 1) % this.words.length;
      const upcoming = this.words[this.index];

      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      // Drop the leaving state once the CSS transition ends so the word can slide in from below next cycle
      setTimeout(() => current.classList.remove('is-leaving'), 500);

      upcoming.classList.add('is-active');
    }
  }

  customElements.define('rotating-word', RotatingWord);
}
